import { render } from "./SetNewPassword.vue?vue&type=template&id=78a31502&scoped=true"
import script from "./SetNewPassword.vue?vue&type=script&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&lang=js"

import "./SetNewPassword.vue?vue&type=style&index=0&id=78a31502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78a31502"]])

export default __exports__